export class FocusStyle {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        focusElements: 'a, button, input, textarea',
        isFocus: '.is--focus'
      },
      classes: {
        isFocus: 'is--focus'
      }
    },
    settings)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this

    this.addFocusEvents()

    document.onkeydown = function (event) {
      const keyEvent = event || window.event

      // Tab
      if (keyEvent.keyCode === 9) {
        that.removeFocus()
      }
    }

    $('body')
      .on({
        click: function (event) {
          $(that.options.selectors.isFocus)
            .not($(event.target))
            .removeClass(that.options.classes.isFocus)
        }
      })
  }

  addFocusEvents (focusElementSelector) {
    const that = this
    const focusElements = focusElementSelector || that.options.selectors.focusElements

    $(focusElements)
      .unbind('focus')
      .on({
        focus: function () {
          const element = $(this)

          element
            .addClass(that.options.classes.isFocus)
        },
        click: function () {
          $(this)
            .not('input, textarea')
            .blur()
        },
        mousedown: function (event) {
          const element = $(this)

          if (element.is('input, textarea')) {
            $(that.options.selectors.isFocus)
              .not(element)
              .removeClass(that.options.classes.isFocus)
          } else {
            event.preventDefault()
            that.removeFocus()
          }
        }
      })
  }

  removeFocus () {
    $(this.options.selectors.isFocus)
      .removeClass(this.options.classes.isFocus)
  }
}

export default FocusStyle
